module.exports = "../static/media/logo.024a847f.png";